import styled from 'styled-components';
import { Tab, Tabs } from 'elc-tabs';
import {
    backgroundWhiteTheme,
    borderBottomTheme,
    filterHeadingTheme,
    clearButtonTheme,
    clearButtonThemeMobile,
    customInputTheme,
    customInputThemeMobile,
    searchTabs,
    searchTabsTab,
    auxiliarSearchButton
} from '../../../theme/default-theme';
import { ContentSpacing, breakpoint } from 'elc-base-theme';

export const SearchActiveScreenWrapper = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    overflow: auto;
    ${backgroundWhiteTheme};
`;

export const InputGroup = styled.div`
    position: relative;
    width: 100%;
    display: table;
    border-collapse: collapse;
    ${borderBottomTheme};
`;

export const ClearButton = styled.button`
    cursor: pointer;
    display: table-cell;
    vertical-align: middle;
    padding: 0;
    outline: inherit;
    margin-right: ${ContentSpacing.space12};
    margin-top: ${ContentSpacing.space48};
    ${filterHeadingTheme};
    ${clearButtonThemeMobile};
    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space28};
    }

    ${breakpoint('desktop')`
        line-height: 30px;
        margin-top: ${ContentSpacing.space48};
        margin-right: ${ContentSpacing.space24};
        ${clearButtonTheme}
        [dir='rtl'] & {
            margin-left: ${ContentSpacing.space24};
        }
    `};
`;

export const InputSearchWrapper = styled.div`
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    padding: ${ContentSpacing.space48} ${ContentSpacing.space12} ${ContentSpacing.space12}
        ${ContentSpacing.space12};
    ${breakpoint('desktop')`
        padding: ${ContentSpacing.space48} ${ContentSpacing.space24} ${ContentSpacing.space24} ${ContentSpacing.space24};
    `};

    .elc-floating-label-string {
        display: none;
    }

    .elc-input-search-field {
        height: auto;
        width: 100%;
        padding: 0;
        ${customInputThemeMobile};
        ${breakpoint('desktop')`
            ${customInputTheme};
        `};
    }
`;

export const InputFieldSearch = styled.input`
    width: 100%;
`;

export const SearchTabs = styled(Tabs)`
    padding: 0;
    width: 100%;
    .elc-tabs {
        &__list {
            flex-flow: row nowrap;
            margin: 0;
            padding: 0 ${ContentSpacing.space20};
            width: 100%;
        }
        &__tab {
            padding: 0;
            margin: ${ContentSpacing.space16} ${ContentSpacing.space40} ${ContentSpacing.space16} 0;
            text-align: start;
            width: auto;
            ${searchTabsTab}
        }

        ${breakpoint('desktop')`
            &__tab {
                margin: ${ContentSpacing.space20} ${ContentSpacing.space40} ${ContentSpacing.space20} 0;
                padding: 0;
                width: auto;
                &:first-child {
                    marin-left: 64px;
                }
            }
        `};
    }

    ${searchTabs}
`;

export const SearchTab = styled(Tab)`
    width: 100%;
`;

export const AuxiliarSearchButton = styled.a`
    align-items: center;
    bottom: 0;
    display: flex;
    height: 42px;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    text-align: center;
    width: 100%;
    ${breakpoint('desktop')`
        height: 56px;
        left: auto;
        position: absolute;
        right: 64px;
        top: 58px;
        width: 164px;
    `};
    ${auxiliarSearchButton}
`;
